const getShiftType = (timestamp) => {
  const hour = new Date(timestamp).getHours();
  if (hour < 8) return 'shift1';
  if (hour < 16) return 'shift2';
  return 'shift3';
};

export const getRecapData = (accounts, hostsInRulesets) => {
  const hostStatsMap = new Map();

  accounts?.forEach((account) => {
    account.datas?.forEach((weekData) => {
      weekData.schedules?.forEach(({ userId, subShiftStartTime }) => {
        if (!hostStatsMap.has(userId)) {
          hostStatsMap.set(userId, {
            workDays: new Set(),
            shift1Count: 0,
            shift2Count: 0,
            shift3Count: 0,
          });
        }

        const stats = hostStatsMap.get(userId);
        const date = new Date(subShiftStartTime);
        const localDateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        stats.workDays.add(localDateString);
        stats[`${getShiftType(subShiftStartTime)}Count`]++;
      });
    });
  });

  return hostsInRulesets.map((host) => {
    const stats = hostStatsMap.get(host.id) || {
      workDays: new Set(),
      shift1Count: 0,
      shift2Count: 0,
      shift3Count: 0,
    };

    return {
      name: {
        name: host.name,
        hostColor: host.bgColor,
        isPregnancy: host.isPregnancy,
      },
      totalWorkDays: stats.workDays.size,
      totalShift1: stats.shift1Count,
      totalShift2: stats.shift2Count,
      totalShift3: stats.shift3Count,
    };
  });
};
